import i18next from "i18next";
import { success, custom } from "./utilities";
import { ToastifyService, paymentService } from "../../services";
import {
  globalSystemConstants,
  paymentConstants,
  contentType,
} from "../../constants";

import { downloadBase64File } from "../../system";

export const paymentCheckout = (paymentData) => {
  return (dispatch) => {
    dispatch(
      custom(paymentConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    paymentService
      .paymentCheckout(paymentData)
      .then((response) => {
        if (response) {
          dispatch(success(response, paymentConstants.CHECKOUT_ID));
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            paymentConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const paymentCheckoutSavedCard = (paymentData) => {
  return (dispatch) => {
    dispatch(
      custom(paymentConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    paymentService
      .paymentCheckoutSavedCard(paymentData)
      .then((response) => {
        if (response) {
          dispatch(success(response, paymentConstants.CHECKOUT_ID_SAVED_CARD));
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            paymentConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const paymentCheckoutNull = () => {
  return (dispatch) => {
    dispatch(success(null, paymentConstants.CHECKOUT_ID_NULL));
  };
};

export const paymentHistory = (paymentData) => {
  return (dispatch) => {
    dispatch(
      custom(paymentConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    paymentService
      .paymentHistory(paymentData)
      .then((response) => {
        if (response) {
          dispatch(success(response, paymentConstants.PAYMENT_HISTORY));
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            paymentConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const paymentHistoryFreelancer = (paymentData) => {
  return (dispatch) => {
    dispatch(
      custom(paymentConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    paymentService
      .paymentHistory(paymentData)
      .then((response) => {
        if (response) {
          dispatch(
            success(response, paymentConstants.PAYMENT_HISTORY_FREELANCER)
          );
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            paymentConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const paymentHistoryStats = (paymentData) => {
  return (dispatch) => {
    dispatch(
      custom(paymentConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    paymentService
      .paymentHistoryStats(paymentData)
      .then((response) => {
        if (response) {
          dispatch(success(response, paymentConstants.PAYMENT_HISTORY_STATS));
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            paymentConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const adminPaymentHistory = (gridState, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(paymentConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    paymentService
      .adminPaymentHistory(gridState)
      .then((response) => {
        if (response) {
          dispatch(success(response, paymentConstants.ADMIN_PAYMENT_HISTORY));
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            paymentConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const exportPaymentHistory = (gridState) => {
  return (dispatch) => {
    paymentService
      .exportPaymentHistory(gridState)
      .then((response) => {
        downloadBase64File(
          response.content,
          contentType.CSV,
          response.fileName
        );
      })
      .catch((error) => {
        ToastifyService.showError(error);
      });
  };
};

export const saveCard = (checkoutId, id) => {
  return (dispatch) => {
    dispatch(
      custom(paymentConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    paymentService
      .saveCard(checkoutId)
      .then((response) => {
        dispatch(paymentActions.getSavedPaymentCard(id));
        if (response) {
          ToastifyService.showSuccess(i18next.t(response));
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            paymentConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
export const deleteCardById = (cardId, idObj) => {
  return (dispatch) => {
    dispatch(
      custom(paymentConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    paymentService
      .deleteCard(cardId)
      .then((response) => {
        dispatch(getSavedPaymentCard(idObj));
        if (response) {
          ToastifyService.showSuccess(response);
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            paymentConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const getSavedPaymentCard = (id, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(paymentConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    paymentService
      .getSavedPaymentCard(id)
      .then((response) => {
        if (response) {
          dispatch(success(response, paymentConstants.SAVED_PAYMENT_CARDS));
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            paymentConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};
export const updateSavedCard = (id, idObj) => {
  return (dispatch) => {
    dispatch(
      custom(paymentConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    paymentService
      .updateSavedCard(id)
      .then((response) => {
        if (response) {
          ToastifyService.showSuccess(i18next.t(response));
          dispatch(getSavedPaymentCard(idObj));
        }
      })
      .catch((error) => {
        ToastifyService.showError(error);
      })
      .finally(() => {
        dispatch(
          custom(
            paymentConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const paymentActions = {
  paymentCheckout,
  paymentCheckoutNull,
  paymentHistory,
  paymentHistoryFreelancer,
  paymentHistoryStats,
  adminPaymentHistory,
  exportPaymentHistory,
  getSavedPaymentCard,
  deleteCardById,
  saveCard,
  updateSavedCard,
  paymentCheckoutSavedCard,
};
